const calculateProgress = (value, total) => parseInt((value/total) * 100);

export default calculateProgress;
